import { useEffect, useRef } from "react";
import type { EChartsOption } from "echarts";

type ChartProps = {
  option: EChartsOption;
  height?: number;
  label: string;
};

export function Chart({ option, height = 320, label }: ChartProps) {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!elementRef.current) return;
    const element = elementRef.current;
    let cancelled = false;
    let chart: ReturnType<(typeof import("../data/echarts-runtime"))["initChart"]> | null = null;
    let observer: ResizeObserver | null = null;
    void import("../data/echarts-runtime").then(({ initChart }) => {
      if (cancelled) return;
      chart = initChart(element, undefined, { renderer: "canvas" });
      chart.setOption(option);
      observer = new ResizeObserver(() => chart?.resize());
      observer.observe(element);
    });
    return () => {
      cancelled = true;
      observer?.disconnect();
      chart?.dispose();
    };
  }, [option]);

  return <div ref={elementRef} className="chart" style={{ height }} role="img" aria-label={label} />;
}

export const chartTextStyle = {
  color: "#dfe8f5",
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
  fontSize: 14,
};

export const chartGridColor = "rgba(199, 216, 232, 0.14)";
